import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { AmountColumnHandler,CardLogoColumnHandler, CardNameColumnHandler, CardNumberColumnHandler, DateColumnHandler, StatusColumnHandler } from './service';
import defaultCard from "../../../../assets/images/default-card.png"
import List from 'src/components/grid.component';
import { badge } from 'src/utils/statusColorsCode';

const CardComponent = ({ cardData, viewtype }) => {
  const navigate = useNavigate();
  const params = useParams()
  const apiTransactionUrl = process.env.REACT_APP_GRID_API + `api/KycService/CustomerCardsK/${params?.id}/All`;
  const gridRef = React.createRef();

  const customerDetailsHandler = useCallback((data) => {
    navigate(`/customer/${params?.id}/customerCards/${data?.cardId}`)
  }, [])

  const dateColumnHandler = (props) => { return (<DateColumnHandler data={props} />) }
  const statusColumnHandler = (props) => { return (<StatusColumnHandler data={props}/>) }
  const amountColumnHandler = (props) => { return (<AmountColumnHandler data={props} />) }
  const cardNumberColumnHandler = (props) => { return (<CardNumberColumnHandler data={props} />) }
  const cardNameColumnHandler = (props) => { return (<CardNameColumnHandler data={props} customerDetailsHandler={customerDetailsHandler} />) }
  const cardLogoColumnHandler = (props) => { return (<CardLogoColumnHandler data={props} />) }
  const customcells = {
    "date": dateColumnHandler,
    "state": statusColumnHandler,
    "amount": amountColumnHandler,
    "cardNumber": cardNumberColumnHandler,
    "cardName": cardNameColumnHandler,
    "": cardLogoColumnHandler
  };

  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [])

  return (
    <>
      {viewtype === 'cardView' ? (
        <div className='p-3.5 relative grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 gap-4'>
          {cardData.map((item) => (<button key={item?.id}
            className='!relative cursor-pointer w-full h-full rounded-2xl object-cover'
            onClick={() => navigate(`/customer/${params?.id}/customerCards/${item?.id}`)}
          >
            {item?.logo && (
              <img
                src={item.logo || defaultCard}
                alt='Card Logo'
                className='w-full h-full rounded-2xl object-cover'
              />
            )}
            <div className="virtual-badge mb-4">{item?.cardType}</div>
            <div className='absolute top-0 left-0 h-full w-full p-4 flex flex-col justify-between'>
              <div className='gap-3 mb-0'>
              </div>
              <div className=''>
                <p className="xl:text-xl md:text-sm text-sm text-textWhite font-semibold text-left" style={{ textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)' }}>{item?.cardName}</p>
              </div>
              <div className='flex gap-2 items-center justify-start'>
                <p className="xl:text-xl md:text-sm text-sm text-textWhite font-semibold text-left" style={{ textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)' }}>{item?.cardNumber !== null ? `XXXX XXXX XXXX ${item?.cardNumber?.substr(-4)}` : 'XXXX XXXX XXXX XXXX'}</p>
                <span className={`px-2 py-1 block rounded-full text-[10px] text-textWhite badge-status badge-bg w-fit leading-none ${badge[item?.state?.toLowerCase()] || "panding"}`}>
                  {item?.state?.toLowerCase() === "approved" ? "Active" : item?.state}
                </span>
              </div>
              <div className='text-left'>
                <p className='text-purewhite xl:text-sm md:text-[10px] text-sm' style={{ textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)' }}>Card Owner</p>
                <p className='xl:text-xl lg:text-xs md:text-sm text-sm text-textWhite font-semibold' style={{ textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)' }}>{item?.userName}</p>
              </div>
              
              <div className='flex justify-between'>
                <div className='text-left'>
                  <span className="text-textWhite font-normal xl:text-sm md:text-[10px] text-sm" style={{ textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)' }}>Balance</span>
                  <span className="xl:text-xl md:text-sm lg:text-xs text-sm font-semibold m-0 text-textWhite block leading-none" style={{ textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)' }}>
                    ${' '}{item?.balance}</span>
              </div>
                <div className='text-left'>
                  <span className="text-textWhite font-normal xl:text-sm md:text-[10px] text-sm" style={{ textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)' }}>CVV</span>
                  <h2 className="xl:text-xl md:text-sm lg:text-xs text-sm font-semibold m-0 text-textWhite leading-none" style={{ textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)' }}>{(item?.cvv === null || item?.cvv) && "***"}</h2>
                </div>
                <div>
                  <span className="text-textWhite font-normal xl:text-sm md:text-[10px] text-sm" style={{ textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)' }}>Exp.Date</span>
                  <h2 className="xl:text-xl md:text-sm lg:text-xs text-sm font-semibold m-0 text-textWhite leading-none" style={{ textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)' }}>{(item?.expireDate === null || item?.expireDate) && "**/**"}</h2>
                </div>
                <div></div>
              </div>
            </div>
          </button>))}
        </div>
      ) : (
          <List
            showExcelExport={false}
            url={apiTransactionUrl}
            ref={gridRef}
            pSize={10}
            className="custom-grid grid-alignment"
            sortable={true}
            screenName={'Customer_Cards'}
            renderCustomCell={renderCustomCell}
            showDisplayColumns={false}
          />
      )
      }
    </>
  );

};
export default CardComponent;
